import { c as e } from "./createLucideIcon-7a477fa6.js";
const c = e("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]);
export {
  c as X
};
